// src/components/Toast.jsx

import React, { useEffect, useState } from 'react';
import './index.scss';

export default function Toast({ id, message, type, duration, onClose }) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const intervalMs = 50;
    const step = (intervalMs / duration) * 100;

    const timer = setInterval(() => {
      setProgress(prev => {
        const next = prev - step;
        return next > 0 ? next : 0;
      });
    }, intervalMs);

    const timeout = setTimeout(() => {
      onClose();
    }, duration);

    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, [duration, onClose]);

  if (!message) return null;

  return (
    <div className={`toast ${type}`}>
      <div className="toast__icon">
        {type === 'success' ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 12l2 2 4-4"
              stroke="#FFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="10" stroke="#FFF" strokeWidth="2" />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 8v4m0 4h.01"
              stroke="#FFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="10" stroke="#FFF" strokeWidth="2" />
          </svg>
        )}
      </div>

      <div className="toast__message">{message}</div>

      <button className="toast__close" onClick={onClose}>
        ×
      </button>

      <div
        className="toast__progress"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}